// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BK9N","importantInfo":"styles_importantInfo__3hTea"};